import { Criteria, ICriteriaTranslatorSet } from 'slipstream-components';
import CSOTranslator from '../translator/CSOTranslator';
import SDTranslator from '../translator/SDTranslator';
import SeciTranslator from '../translator/SeciTranslator';

export class DefaultTranslatorSet implements ICriteriaTranslatorSet {
  private static DEFAULT_TRANS = 'CSO';
  private translators = {
    CSO: new CSOTranslator(),
    SD: new SDTranslator(),
    SECI: new SeciTranslator(),
  };

  public translateToPost(c: Criteria) {
    const type = c.type || DefaultTranslatorSet.DEFAULT_TRANS;
    const translator = this.translators[type];
    if (translator == null) {
      throw new Error('The type of specified criteria has not translator: ' + type);
    }
    return translator.translateToPost(c);
  }

  public translateToGet(c: Criteria) {
    const type = c.type || DefaultTranslatorSet.DEFAULT_TRANS;
    const translator = this.translators[type];
    if (translator == null) {
      throw new Error('The type of specified criteria has not translator: ' + type);
    }
    return translator.translateToGet(c);
  }

  public getTranslator(name: string) {
    return this.translators[name];
  }
}
